var DateFormat;
(function (DateFormat) {
  DateFormat["Short"] = "short";
  DateFormat["Medium"] = "medium";
  DateFormat["Long"] = "long";
})(DateFormat || (DateFormat = {}));

var TimeFormat;
(function (TimeFormat) {
  TimeFormat["Auto"] = "auto";
  TimeFormat["H12"] = "h12";
  TimeFormat["H23"] = "h23";
})(TimeFormat || (TimeFormat = {}));

export { DateFormat as D, TimeFormat as T };
